import { render, staticRenderFns } from "./Satac.vue?vue&type=template&id=77bcdac6&"
import script from "./Satac.vue?vue&type=script&lang=js&"
export * from "./Satac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports